export default {
  API_ENDPOINT: `https://infinite-depths-29223.herokuapp.com/api/`
}